import React from "react";
import ContactUsForm from "./ContactUsForm";

const ContactForm = () => {
  return (
    <div className="rounded-2xl p-7 lg:p-10"
         style={{ background: 'var(--bg-card)', border: '1px solid var(--border-color)' }}>
      <h3 className="text-2xl font-bold tracking-tight mb-2" style={{ color: 'var(--text-primary)' }}>
        Send us a message
      </h3>
      <p className="text-sm mb-8" style={{ color: 'var(--text-secondary)' }}>
        Tell us more about yourself and what you've got in mind.
      </p>

      <ContactUsForm />
    </div>
  );
};

export default ContactForm;